import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatTreeModule } from '@angular/material/tree';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';

import { SharedModule } from 'app/shared/shared.module';
import { IntegrationsService } from './integrations.service';
import { integrationsRoutes } from './integrations.routing';
import { IntegrationsSettingsComponent } from './integrations.component';
import { IntegrationsListComponent } from './components/integrations-list/integrations-list.component';
import { OneDriveIntegrationComponent } from './components/one-drive-integration/one-drive-integration.component';
import { EgnyteSubDomainModalComponent } from './components/egnyte/egnyte-subdomain-modal/egnyte-subdomain-modal.component';

@NgModule({
  declarations: [
    IntegrationsSettingsComponent,
    IntegrationsListComponent,
    OneDriveIntegrationComponent,
    EgnyteSubDomainModalComponent,
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(integrationsRoutes),
    MatButtonModule,
    MatExpansionModule,
    MatIconModule,
    MatTreeModule,
    MatSidenavModule,
    MatProgressSpinnerModule,
    MatCardModule,
    MatCheckboxModule,
    MatProgressBarModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    SharedModule,
  ],
  providers: [IntegrationsService],
})
export class IntegrationsModule {}
